import {
  createFileRoute,
  Outlet,
  useRouteContext,
  redirect,
} from '@tanstack/react-router';
import { isSessionExpiredError } from '@repo/api-client';
import { practitionerQueryFn } from '~/services/practitioner/usePractitioner';
import AuthedLayout from '~/components/layouts/AuthedLayout/AuthedLayout';
import Login from '~/components/Auth/Login/Login';
import PublicLayout from '~/components/layouts/PublicLayout/PublicLayout';

const AuthedComponent = () => {
  return (
    <AuthedLayout>
      <Outlet />
    </AuthedLayout>
  );
};

export const Route = createFileRoute('/_authed')({
  beforeLoad: async ({ context, location }) => {
    if (!context.isAuthenticated) {
      throw redirect({
        to: '/login',
        search: {
          redirect: location.href,
        },
      });
    }
  },
  loader: async ctx => {
    const {
      queryClient,
      user,
      isPractitioner,
      isImpersonating,
      impersonationId,
    } = ctx.context;

    // Use impersonationId when impersonating, otherwise use user.id
    const userId = isImpersonating ? impersonationId : user?.id;

    if (userId && isPractitioner) {
      try {
        const practitioner = await queryClient.ensureQueryData(
          practitionerQueryFn(userId, isPractitioner),
        );
        return { practitioner };
      } catch (error) {
        // A thrown redirect also works during SSR, where `window` is absent.
        if (isSessionExpiredError(error)) {
          throw redirect({ to: '/logout' });
        }
        console.error('[_authed loader] Error fetching practitioner:', error);
        return { practitioner: null };
      }
    }

    return { practitioner: null };
  },
  component: AuthedComponent,
});
